import React from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Form from "react-bootstrap/Form";
import knowledgeInvestWM from "../../asset/images/banner_wm.svg";
import knowledgeInvestDM from "../../asset/images/banner_dm.svg";
import knowledgePiggyBank from "../../asset/images/knowledge-ans.svg";
import { useEffect } from "react";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function KnowledgeCenterModules() {
  return (
    <>
      <Header />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="knowledge">
        <div className="knowledge-header">
          <h2 className="knowledge-header-title">Modules</h2>
          <div className="knowledge-header-option">
            {/* search-bar */}
            <div className="search-box">
              <form action="#" method="post">
                <div className="form-group">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search modules by text, keywords, etc..."
                    autoComplete="off"
                  />
                  <input
                    type="submit"
                    name="submit"
                    value="submit"
                    className="submit-btn"
                  />
                </div>
              </form>
            </div>
            {/* dropdown-filter */}
            <div className="dropdown-filter">
              <Form.Select size="lg" aria-label="Default select example">
                <option value="largecap">English</option>
                <option value="smallcap">Hindi</option>
                <option value="midcap">French</option>
              </Form.Select>
            </div>
            {/* switch tab */}
            <ul
              className="nav nav-tabs filter-tabs"
              id="knowledgeTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="module-tab"
                  data-toggle="tab"
                  data-target="#module-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="module-tab-pane"
                  aria-selected="true"
                >
                  Modules
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="video-tab"
                  data-toggle="tab"
                  data-target="#video-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="video-tab-pane"
                  aria-selected="false"
                >
                  Videos
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content refer-tab-content" id="knowledgeTabContent">
          <div
            className="tab-pane fade show active"
            id="module-tab-pane"
            role="tabpanel"
            aria-labelledby="module-tab"
            tabIndex={0}
          >
            <div className="knowledge-chapter">
              <div className="knowledge-chapter-left">
                <a
                  href="javascript:void(0)"
                  className="knowledge-chapter-left-btn"
                  id="closeChapter"
                >
                  <i className="icon-arrow-left"></i>
                </a>
                <h4 className="knowledge-chapter-left-heading">
                  Learn Investing with the Experts
                </h4>
                <div className="knowledge-chapter-left-text">
                  <p>1. Part - I</p>
                  <ul className="dots">
                    <li>Importance of Investing</li>
                    <li>Right Time to Invest</li>
                    <li>Waiting / Worrying while Investing</li>
                    <li>Importance of Patience</li>
                    <li>Goal & Real Estate Investment</li>
                  </ul>
                </div>
                <div className="knowledge-chapter-left-text">
                  <p>2. Part - II</p>
                  <ul className="dots">
                    <li>Class Details :-</li>
                    <li>Class Details :-</li>
                    <li>Class Details :-</li>
                    <li>Class Details :-</li>
                    <li>Class Details :-</li>
                  </ul>
                </div>
                <p className="knowledge-chapter-left-text">
                  Difference between Saving & Investment
                </p>
                <p className="knowledge-chapter-left-text">
                  Child Investment Plan
                </p>
                <p className="knowledge-chapter-left-text">
                  Retirement Planning
                </p>
                <p className="knowledge-chapter-left-text">
                  How to Invest in Stock Market
                </p>
                <p className="knowledge-chapter-left-text">
                  What is Stock Market
                </p>
                <p className="knowledge-chapter-left-text">
                  What is Demat Account
                </p>
                <p className="knowledge-chapter-left-text">
                  Difference Between Demat & Trading Account
                </p>
                <p className="knowledge-chapter-left-text">What is a trader</p>
                <p className="knowledge-chapter-left-text">What is Investing</p>
                <p className="knowledge-chapter-left-text">
                  Trading Sessions & it’s types
                </p>
                <p className="knowledge-chapter-left-text">
                  What is Payin & Payout
                </p>
                <p className="knowledge-chapter-left-text">
                  Wahat is Offer for Sale ( OFS )
                </p>
                <p className="knowledge-chapter-left-text">
                  Buy Back of Shares
                </p>
              </div>
              <div className="knowledge-chapter-right">
                <h3 className="knowledge-chapter-right-heading">
                  Learn Investing with the Experts
                </h3>

                {/* {snapshotDiffValue === 0 ? null : snapshotDiffValue < 0 ? (
                  <img src={knowledgeInvestDM} alt="Down Arrow" />
                ) : (
                  <img src={knowledgeInvestWM} alt="Up Arrow" />
                )} */}

                <img
                  src={knowledgeInvestWM}
                  alt="knowledgeInvestWM"
                  className="knowledge-chapter-right-img knowledge-wt-img"
                />

                <img
                  src={knowledgeInvestDM}
                  alt="knowledgeInvestDM"
                  className="knowledge-chapter-right-img knowledge-dm-img"
                />
                {/* )} */}
                <div className="chapter-response">
                  <h3 className="chapter-question">
                    1.1 Why should one Invest?
                  </h3>
                  <div className="chapter-solution">
                    <p>
                      {" "}
                      Before we address the above question, let us understand
                      what would happen if one chooses not to invest. Let us
                      assume you earn Rs.50,000/- per month, and you spend
                      Rs.30,000/-towards your cost of living, which includes
                      housing, food, transport, shopping, medical, etc. The
                      balance of Rs.20,000/- is your monthly surplus. For the
                      sake of simplicity, let us ignore the effect of personal
                      income tax in this discussion.
                    </p>
                    <h4 className="list-title">
                      To drive the point across, let us make a few simple
                      assumptions.
                    </h4>
                    <ul className="list">
                      <li>
                        The employer is kind enough to give you a 10% salary
                        hike every year.
                      </li>
                      <li>
                        {" "}
                        The cost of living is likely to go up by 8% year on
                        year.
                      </li>
                      <li>
                        You are 30 years old and plan to retire at 50. This
                        leaves you with 20 more years to earn
                      </li>
                      <li>You don’t intend to work after you retire.</li>
                      <li>
                        Your expenses are fixed and don’t foresee any other
                        expense.
                      </li>
                      <li>
                        The balance cash of Rs.20,000/- per month is retained in
                        the form of hard cash.
                      </li>
                      <li>
                        Going by these assumptions, here is how the cash balance
                        will look like in 20 years.
                      </li>
                    </ul>
                  </div>
                  <h3 className="chapter-question">1.2 Where to invest?</h3>
                  <div className="chapter-solution">
                    <p>
                      Having figured out the reasons to invest, the next obvious
                      question would be – Where would one invest, and what are
                      the returns one could expect by investing.
                    </p>
                    <p>
                      When it comes to investing, one has to choose an asset
                      class that suits the individual’s risk and return
                      temperament.
                    </p>
                    <p>
                      An asset class is a category of investment with particular
                      risk and return characteristics. The following are some of
                      the popular asset classes.
                    </p>
                    <div className="chapter-solution-dual">
                      <img
                        src={knowledgePiggyBank}
                        alt=""
                        className="Knowledge-piggy-img"
                      />
                      <div className="chapter-solution-right">
                        <p>Fixed Income Instruments</p>
                        <ul className="list">
                          <li>
                            {" "}
                            These are investable instruments with minimal risk
                            to the principle, and the return is paid as an
                            interest to the investor based on the particular
                            fixed-income instrument. The interest paid could be
                            quarterly, semi-annual or annual intervals. At the
                            end of the term of deposit, (also known as maturity
                            period) the capital is returned to the investor.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <p>Typical fixed income investment includes:</p>
                    <ul className="list">
                      <li>Fixed deposits offered by banks.</li>
                      <li>Bonds issued by the Government of India</li>
                      <li>Bonds issued by the Government of India</li>
                      <li>Bonds issued by corporate’s</li>
                      <li>
                        As of June 2014, the typical return from a fixed income
                        instrument varies between 8% and 11%.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="video-tab-pane"
            role="tabpanel"
            aria-labelledby="video-tab"
            tabIndex={0}
          ></div>
        </div>
      </main>
    </>
  );
}

export default KnowledgeCenterModules;
